import { i18n } from '@/i18n'

export const validRoles = (company, config) => {
  if (company == null || config == null) return []
  return company.company_type === 'industry' ? config.valid_roles_industry : config.valid_roles_branch
}

export const roleOptions = validRoles =>
  validRoles.map(role => ({
    label: i18n.t(`meta.roles.${role}`),
    value: role,
  }))
